import { render, staticRenderFns } from "./PPPI_Navbar.vue?vue&type=template&id=0eef765a&scoped=true"
import script from "./PPPI_Navbar.vue?vue&type=script&lang=js"
export * from "./PPPI_Navbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eef765a",
  null
  
)

export default component.exports